import GenericActionField from 'automation-ui-action-features/actions/extension/generic-extension/GenericActionField';

// NOTE(bheng): I don't have a good name, but it's internal to the file.

const isSingleFieldDependency = dependency => dependency.dependencyType === 'SINGLE_FIELD';
const isConditionalSingleFieldDependency = dependency => dependency.dependencyType === 'CONDITIONAL_SINGLE_FIELD';
export const isParentChildrenFieldDependency = dependency => dependency.dependencyType === 'PARENT_CHILDREN';
const isGenericActionField = value => value instanceof GenericActionField;
const areDependenciesMet = ({
  allFieldDependencies,
  currentFieldDependencies,
  metadataFields
}) => currentFieldDependencies.every(dependency => {
  if (isConditionalSingleFieldDependency(dependency)) {
    const {
      controllingFieldName,
      controllingFieldValue
    } = dependency;
    const controllingField = metadataFields.find(field => field.fieldKey === controllingFieldName);
    if (!isGenericActionField(controllingField)) {
      return false;
    }
    return !!controllingField.fieldValue && controllingField.fieldValue.getValue() === controllingFieldValue;
  } else if (isParentChildrenFieldDependency(dependency)) {
    const {
      parentFieldName,
      editability,
      visibility: {
        type: visibilityType
      }
    } = dependency;
    switch (visibilityType) {
      case 'ALWAYS_VISIBLE':
        {
          return true;
        }
      case 'VISIBLE_WHEN_PARENT_VISIBLE':
        {
          // parents of VISIBLE_WHEN_PARENT_VISIBLE can only be fields, not actions
          return showDependentField({
            fieldKey: parentFieldName,
            inputFieldDependencies: allFieldDependencies,
            metadataFields
          });
        }
      case 'VISIBLE_WHEN_EDITABLE':
        {
          var _parentField$fieldVal, _editability$parentVa;
          const parentField = metadataFields.find(field => field.fieldKey === parentFieldName);
          if (!isGenericActionField(parentField)) {
            return false;
          }
          const parentFieldValue = (_parentField$fieldVal = parentField.fieldValue) === null || _parentField$fieldVal === void 0 ? void 0 : _parentField$fieldVal.getValue();
          const controllingFieldValueMet = !!parentFieldValue && (editability.type === 'ANY_PARENT_VALUE' || editability.type === 'SPECIFIC_PARENT_VALUE' && ((_editability$parentVa = editability.parentValues) === null || _editability$parentVa === void 0 ? void 0 : _editability$parentVa.includes(parentFieldValue)));
          return controllingFieldValueMet;
        }
      default:
        {
          // should never happen
          reportError({
            error: new Error(`[areDependenciesMet]: invalid visibilityType ${dependency}`)
          });
          return false;
        }
    }
  } else if (isSingleFieldDependency(dependency)) {
    // NOTE: this check is only for field visibility. single fields only control editability, and should be filtered out beforehand
    return false;
  } else {
    // should never happen
    reportError({
      error: new Error(`[areDependenciesMet]: invalid InputFieldDependency type ${dependency}`)
    });
    return false;
  }
});
export function showDependentField({
  fieldKey,
  inputFieldDependencies,
  metadataFields
}) {
  const dependencies = inputFieldDependencies.filter(inputFieldDependency => {
    if (isConditionalSingleFieldDependency(inputFieldDependency)) {
      return inputFieldDependency.dependentFieldNames.includes(fieldKey);
    } else if (isParentChildrenFieldDependency(inputFieldDependency)) {
      return inputFieldDependency.childFieldNames.includes(fieldKey);
    }
    return false;
  });
  return !dependencies.length || areDependenciesMet({
    allFieldDependencies: inputFieldDependencies,
    currentFieldDependencies: dependencies,
    metadataFields
  });
}
export function showDependentFieldSet({
  fieldKey,
  inputFieldDependencies,
  metadataFields
}) {
  const dependencies = inputFieldDependencies.filter(inputFieldDependency => {
    if (isConditionalSingleFieldDependency(inputFieldDependency)) {
      var _inputFieldDependency;
      return (_inputFieldDependency = inputFieldDependency.dependentActionNames) === null || _inputFieldDependency === void 0 ? void 0 : _inputFieldDependency.includes(fieldKey);
    } else if (isParentChildrenFieldDependency(inputFieldDependency)) {
      return inputFieldDependency.childActionNames.includes(fieldKey);
    }
    return false;
  });
  return !dependencies.length || areDependenciesMet({
    allFieldDependencies: inputFieldDependencies,
    currentFieldDependencies: dependencies,
    metadataFields
  });
}